const swiperFeatBlogs = new Swiper('.featured-blogs__contents', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
      el: '.swiper-pagination-col',
      clickable: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    980: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  }
});